"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Check = _interopRequireDefault(require("@insided/shared/icons/Check"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _classnames = _interopRequireDefault(require("classnames"));

var InlineTitleEditor = function InlineTitleEditor(_ref) {
  var initialValue = _ref.initialValue,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Dropdown name' : _ref$placeholder,
      _ref$isExpanded = _ref.isExpanded,
      isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      className = _ref.className;
  var inputRef = null;

  var handleConfirm = function handleConfirm(e) {
    e.stopPropagation();

    if (inputRef) {
      onConfirm(inputRef.value);
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter') {
      handleConfirm(e);
    } else if (e.key === 'Escape') {
      e.stopPropagation();
      onCancel();
    }
  };

  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('inline-title-editor', className, {
      'inline-title-editor--expanded': isExpanded
    })
  }, (0, _preact.h)("input", {
    ref: function ref(_ref2) {
      inputRef = _ref2;
      if (_ref2) _ref2.value = initialValue !== null && initialValue !== void 0 ? initialValue : '';
    },
    type: "text",
    className: "inline-title-editor__input",
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onKeyDown: handleKeyDown,
    placeholder: placeholder,
    autoFocus: true
  }), (0, _preact.h)("div", {
    className: "inline-title-editor__actions"
  }, (0, _preact.h)("button", {
    type: "button",
    className: "inline-title-editor__action-btn",
    onClick: handleConfirm,
    "aria-label": "Confirm"
  }, (0, _preact.h)(_Check.default, {
    width: 16,
    height: 16
  })), (0, _preact.h)("button", {
    type: "button",
    className: "inline-title-editor__action-btn",
    onClick: function onClick(e) {
      e.stopPropagation();
      onCancel();
    },
    "aria-label": "Cancel"
  }, (0, _preact.h)(_Close.default, {
    width: 16,
    height: 16
  }))));
};

var _default = InlineTitleEditor;
exports.default = _default;